module.exports = __webpack_public_path__ + "img/singer-sia.d73b95a4.png";